module.exports = __webpack_public_path__ + "static/portfolio-cover.f113e0a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio-cover.jpg
// module id = 126
// module chunks = 203139113684000 272362882329030